import { makeStyles } from '@material-ui/styles'

const rangeDateSectionStyles = makeStyles(theme => ({
  datesContainer: {
    width: '100%',
    display: 'flex',
  },
  datePicker: {
    marginRight: theme.spacing(2.4),
  },
}))

export default rangeDateSectionStyles
